import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Footer extends Component {

  render() {
    return (
      <footer className="footer py-7">
        <div className="container">
          <div className="row gap-y">

            <div className="col-xl-4 order-md-last">
              <h6 className="mb-4"><strong>Get Started</strong></h6>
              <p>Form so, head allowed how found at right, chosen put sad. Copy of field phase offers texts. Great family there first about that.</p>
              <Link className="btn btn-primary mr-2" to="">Start - Free</Link>
              <Link className="btn btn-secondary" to="" data-toggle="modal" data-target="#modal-contact">Contact</Link>
            </div>

            <div className="col-6 col-md-4 col-xl-2">
              <h6 className="mb-4"><strong>Product</strong></h6>
              <div className="nav flex-column">
                <Link className="nav-link" to="/Product">Features</Link>
                <Link className="nav-link" to="/Pricing">Pricing</Link>
              </div>
            </div>

            <div className="col-6 col-md-4 col-xl-2">
              <h6 className="mb-4"><strong>Company</strong></h6>
              <div className="nav flex-column">
                <Link className="nav-link" to="/About">About</Link>
                <Link className="nav-link" to="/Team">Team</Link>
                <Link className="nav-link" to="/Career">Career</Link>
              </div>
            </div>

            <div className="col-xl-4 order-md-first">
              <h6 className="mb-4"><strong>We Are Awesome</strong></h6>
              <p>We’re a team of experienced designers and developers. We can combine beautiful, modern designs with clean, functional and high-performance code to produce stunning websites.</p>
              <small className="opacity-70">© 2018 WeLoop. All rights reserved.</small>
            </div>
          </div>
        </div>
 
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js